import type { ChangelogEntry } from "../types";

/** Booking av utstyr på prosjekter, med kalender og status i utstyrslista. */
export const UTSTYRSBOOKING_2026_10: ChangelogEntry = {
  id: "2026-10-24-utstyrsbooking",
  date: "2026-10-24",
  title: "Book utstyr på prosjekter",
  summary:
    "Utstyr kan bookes på et prosjekt eller internt, med egne datoer, antall og notat per utstyr. Dobbelbooking gir advarsel, men kan lagres.",
  sections: [
    {
      heading: "Utstyr",
      minRole: "user",
      items: [
        {
          title: "Ny fane «Utstyr» på prosjektet",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Viser hvilket utstyr som er booket og når. ⚠ betyr at utstyret også er booket et annet sted de samme dagene. Klikk på en rad for å endre eller avbestille bookingen.",
        },
        {
          title: "Book utstyr",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Velg prosjekt eller Internt med tittel, ansvarlig og standarddatoer, og søk opp utstyret. Hver linje kan få egne datoer, antall og et notat som «Hvem tar med …». Er noe allerede booket, vises det i dialogen, og knappen blir «Book likevel».",
        },
        {
          title: "Kalender på utstyrskortet",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Månedskalender med bookingene. Klikk på en dag for å booke fra den datoen, eller på en booking for å åpne den. Fakta viser «Brukt 12 mnd», dagene utstyret har vært booket det siste året.",
        },
        {
          title: "Status og «Ledig i periode» i utstyrslista",
          kind: "forbedret",
          featureFlag: "feature_equipment",
          body: "Status viser Ledig, Booket med datoer, hvor mange som er ledige av utstyr vi har flere av, ⚠ Dobbeltbooket eller På service. «Ledig i periode» viser bare utstyr som har minst ett ledig alle dagene du velger.",
        },
      ],
    },
  ],
};
